<template>
  <router-view />
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers("classifier");

/**
 * A simple component to work as wrapper of the other views that depends
 * on the `classificationsSellerId` present in the route.
 * Also this component ensures to set as the store's `classificationsSellerId`
 * the one present in the route.
 */
export default {
  computed: {
    ...mapState(["classificationsSellerId"])
  },
  methods: {
    ...mapActions(["setClassificationsSellerId"]),
    setSellerId() {
      const sellerId = this.$route.params.classificationsSellerId;
      if (sellerId !== this.classificationsSellerId) {
        this.setClassificationsSellerId(sellerId).catch(() =>
          this.$router.push({ name: "classifier/sellers" })
        );
      }
    }
  },
  watch: {
    $route() {
      this.setSellerId();
    }
  },
  created() {
    this.setSellerId();
  }
};
</script>